import { settingsApiClient } from "@api/settings-api-client";
import { UserId } from "@custom-types/base-types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { SettingsApiTypes } from "@stellar/settings-api-client";
import { UserBatchSettingsResponse, UserSettingsIdentifier, UserSettingsResponse } from "@store/settings/settings-slice-types";

interface FetchBatchUserSettingsProps {
  /** The identifiers of the user settings to fetch */
  identifiers: UserSettingsIdentifier[];
  /** The user ID for whom the settings are being fetched */
  userId: UserId;
}

/**
 * Fetches user settings in batch.
 * @throws {Error} if the Settings API client request fails
 */
export const fetchUserSettings = createAsyncThunk<
  UserBatchSettingsResponse,
  FetchBatchUserSettingsProps
>(
  "settings/fetchUserSettings",
  async ({
    identifiers,
    userId: _userId,
  }) => {
    return await settingsApiClient.user.fetchUserBatchSettings(
     identifiers
    );
    
  });

interface UpdateUserSettingProps<Identifier extends UserSettingsIdentifier> {
  /** The identifier of the setting to update */
  identifier: Identifier;
  /** The user ID for whom the setting is being updated */
  userId: UserId;
  /** The payload to update the setting with */
  payload: SettingsApiTypes.UpdateSettingPayload<"USER", Identifier>;
}

/**
 * Updates a single user setting and returns the updated setting.
 */
export const updateUserSetting = createAsyncThunk<
  { userId: UserId; setting: UserSettingsResponse },
  UpdateUserSettingProps<UserSettingsIdentifier>
>(
  "settings/updateUserSetting",
  async ({ identifier, userId, payload }) => {
    const updatedSetting = await settingsApiClient.user.updateUserSettings(
      identifier,
      payload
    );
    return {
      userId,
      setting: updatedSetting,
    };
  }
);